import { Link } from "react-router-dom";
import styles from "./Articles.module.scss";

export const Article5 = () => {
  return (
    <div className={styles.articles__wrapper}>
      <Link to={"/articles"}>&#8592; Назад к статьям</Link>
      <h5 className={styles.articles__header}>
        Платформа для трансформационных игр PSYCards по самой доступной
        стоимости.
      </h5>
      <p className={styles.articles__pharagraph}>
        Трансформационные игры представляют собой игры, которые помогают
        человеку разобраться в себе, познать самого себя, раскрыть свои таланты,
        больше узнать о своих способностях, желаниях, убеждениях. Если вы хотите
        приобрести, но не знаете, <b>где купить трансформационную игру</b>, наш
        сайт станет для вас настоящей находкой.
      </p>
      <h5 className={styles.articles__header}>
        Какие существуют трансформационные игры
      </h5>
      <p className={styles.articles__pharagraph}>
        Эти групповые игры направлены на работу с личными запросами самого
        человека. Участники игры находят оптимальные решения, которые помогают
        им преодолевать те или иные трудности, справиться с личностными
        кризисами, сложной ситуацией, достигнуть поставленных целей.
      </p>
      <p className={styles.articles__pharagraph}>
        Такие игры помогают запустить процесс сознания. С их помощью человек
        может многое понять, переосмыслить, увидеть себя совершенно с иного
        ракурса. После игр он начинает воспринимать ситуацию по-другому,
        меняется его отношение к проблеме. Ему становится проще принимать
        окружающую реальность. Существуют следующие{" "}
        <b>виды трансформационных игр:</b>
        <ul className={styles.articles__ul}>
          <li>Лила Чакра;</li>
          <li>Казуальный Интеллект;</li>
          <li>Трансформация;</li>
          <li>Cashflow;</li>
          <li>Игры жизни;</li>
          <li>Genesis;</li>
          <li>Тамболия.</li>
        </ul>
      </p>
      <h5 className={styles.articles__header}>Возможности PSYCards</h5>
      <p className={styles.articles__pharagraph}>
        Приложение PSYCards – это <b>платформа для трансформационных игр</b>.
        Она служит для проведения психологических консультаций, а также
        трансформационных игр. Данная платформа позволяет:
        <ul className={styles.articles__ul}>
          <li>проводить консультации с применением МАК;</li>
          <li>эффективно проводить трансформационные игры;</li>
          <li>работать с картами таро;</li>
          <li>работать с классическими версиями Скайп, Зум;</li>
          <li>приглашать клиентов на сессии.</li>
        </ul>
      </p>
      <p className={styles.articles__pharagraph}>
        Благодаря данному приложению можно организовывать и проводить любые
        трансформационные игры. К основным преимуществам PSYCard относятся:
        <ul className={styles.articles__ul}>
          <li>простота и удобство во время работы;</li>
          <li>имеются все инструкции, которые помогают быстро обучиться;</li>
          <li>надежная техподдержка;</li>
          <li>регулярное обновление приложения;</li>
          <li>быстрое исправление ошибок;</li>
          <li>оперативная обработка заказа;</li>
          <li>возможность участвовать в развитии данного приложения.</li>
        </ul>
      </p>
      <p className={styles.articles__pharagraph}>
        Обратившись к нам, вы можете приобрести нужную для вас версию
        приложения. Чтобы убедиться в высоком качестве и надежности программы,
        можете прочитать отзывы довольных клиентов. Предлагаем лучшие условия
        для заказчиков. Теперь проводить трансформационные игры будет проводить
        легко и удобно. Если у вас возникли дополнительные вопросы, то свяжитесь
        с нами по указанному на сайте номер телефона. Охотно предоставим любую
        информацию о платформе.
      </p>
    </div>
  );
};
